module.exports = __webpack_public_path__ + "img/gallery04.edec7ee5.png";